import { useState } from "react";
import * as MUI from "@mui/material";
import * as Icon from "@mui/icons-material";
import { useLocation, Link } from "react-router-dom";
import { useAuth } from "../../hooks/auth";

export const MenuLateralUsuario: React.FC = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const toggleDrawerOpen = (): void => setDrawerOpen(!drawerOpen);
  const { pathname } = useLocation();
  const { user } = useAuth();

  const grupo = user?.grupo;
  const acesso = user?.tipo_acesso.id_acesso;

  const theme = MUI.useTheme();
  const mdDown = MUI.useMediaQuery(theme.breakpoints.down("md"));

  return (
    <>
      {mdDown ? (
        <MUI.Box>
          <MUI.IconButton onClick={toggleDrawerOpen}>
            <Icon.Menu />
          </MUI.IconButton>
          <MUI.Drawer
            anchor="left"
            open={drawerOpen}
            onClose={toggleDrawerOpen}
          >
            <MUI.Box
              display="flex"
              flexDirection="column"
              height="100%"
              width={theme.spacing(28)}
              bgcolor={theme.palette.primary.light}
            >
              <MUI.List>
                <MUI.Typography
                  sx={{ color: "#fff !important" }}
                  variant="h6"
                  textAlign="center"
                >
                  Usuário
                </MUI.Typography>
                {grupo === 1 || acesso === "2" ? (
                  <MUI.ListItemButton
                    component={Link}
                    to="/gerenciamentodeusuario/cadastro-usuario"
                    selected={
                      pathname === "/gerenciamentodeusuario/cadastro-usuario"
                    }
                    sx={{
                      "&.Mui-selected": {
                        backgroundColor: `${theme.palette.primary.main}`,
                        "&.Mui-focusVisible": {
                          backgroundColor: `${theme.palette.primary.dark}`,
                        },
                        ":hover": {
                          backgroundColor: `${theme.palette.primary.dark}`,
                        },
                      },
                    }}
                  >
                    <MUI.ListItemIcon>
                      <Icon.PersonAddAlt1 sx={{ color: "white" }} />
                    </MUI.ListItemIcon>
                    <MUI.ListItemText sx={{ color: "white" }}>
                      Cadastro de usuário
                    </MUI.ListItemText>
                  </MUI.ListItemButton>
                ) : (
                  false
                )}

                <MUI.ListItemButton
                  component={Link}
                  to="/gerenciamentodeusuario/lista-usuario"
                  selected={
                    pathname === "/gerenciamentodeusuario/lista-usuario"
                  }
                  sx={{
                    "&.Mui-selected": {
                      backgroundColor: `${theme.palette.primary.main}`,
                      "&.Mui-focusVisible": {
                        backgroundColor: `${theme.palette.primary.dark}`,
                      },
                      ":hover": {
                        backgroundColor: `${theme.palette.primary.dark}`,
                      },
                    },
                  }}
                >
                  <MUI.ListItemIcon>
                    <Icon.PersonSearch sx={{ color: "white" }} />
                  </MUI.ListItemIcon>
                  <MUI.ListItemText sx={{ color: "white" }}>
                    Lista de usuários
                  </MUI.ListItemText>
                </MUI.ListItemButton>

                <MUI.ListItemButton component={Link} to="/pagina-inicial">
                  <MUI.ListItemIcon>
                    <Icon.KeyboardReturn sx={{ color: "white" }} />
                  </MUI.ListItemIcon>
                  <MUI.ListItemText sx={{ color: "white" }}>
                    Voltar página inicial
                  </MUI.ListItemText>
                </MUI.ListItemButton>
              </MUI.List>
            </MUI.Box>
          </MUI.Drawer>
        </MUI.Box>
      ) : (
        <MUI.Box
          display="flex"
          flexDirection="column"
          height="100%"
          width={theme.spacing(31)}
          bgcolor={theme.palette.primary.light}
        >
          <MUI.List>
            <MUI.Typography
              sx={{ color: "#fff !important" }}
              variant="h6"
              textAlign="center"
            >
              Gerenciamento de usuário
            </MUI.Typography>
            {grupo === 1 || acesso === "2" ? (
              <MUI.ListItemButton
                component={Link}
                to="/gerenciamentodeusuario/cadastro-usuario"
                selected={
                  pathname === "/gerenciamentodeusuario/cadastro-usuario"
                }
                sx={{
                  "&.Mui-selected": {
                    backgroundColor: `${theme.palette.primary.main}`,
                    "&.Mui-focusVisible": {
                      backgroundColor: `${theme.palette.primary.dark}`,
                    },
                    ":hover": {
                      backgroundColor: `${theme.palette.primary.dark}`,
                    },
                  },
                }}
              >
                <MUI.ListItemIcon>
                  <Icon.PersonAddAlt1 sx={{ color: "white" }} />
                </MUI.ListItemIcon>
                <MUI.ListItemText sx={{ color: "white" }}>
                  Cadastro de usuário
                </MUI.ListItemText>
              </MUI.ListItemButton>
            ) : (
              false
            )}

            <MUI.ListItemButton
              component={Link}
              to="/gerenciamentodeusuario/lista-usuario"
              selected={pathname === "/gerenciamentodeusuario/lista-usuario"}
              sx={{
                "&.Mui-selected": {
                  backgroundColor: `${theme.palette.primary.main}`,
                  "&.Mui-focusVisible": {
                    backgroundColor: `${theme.palette.primary.dark}`,
                  },
                  ":hover": {
                    backgroundColor: `${theme.palette.primary.dark}`,
                  },
                },
              }}
            >
              <MUI.ListItemIcon>
                <Icon.PersonSearch sx={{ color: "white" }} />
              </MUI.ListItemIcon>
              <MUI.ListItemText sx={{ color: "white" }}>
                Lista de usuários
              </MUI.ListItemText>
            </MUI.ListItemButton>

            <MUI.ListItemButton component={Link} to="/pagina-inicial">
              <MUI.ListItemIcon>
                <Icon.KeyboardReturn sx={{ color: "white" }} />
              </MUI.ListItemIcon>
              <MUI.ListItemText sx={{ color: "white" }}>
                Voltar página inicial
              </MUI.ListItemText>
            </MUI.ListItemButton>
          </MUI.List>
        </MUI.Box>
      )}
    </>
  );
};
